import styled from "styled-components";
import { Cores } from "../../styles/GlobalStyles";
export const ReviewsCss = styled.section`
  padding: 4rem 0;
  background-color: ${Cores.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const Title = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.1rem;
    color: #666;
  }

  @media (max-width: 768px) {
    margin-bottom: 2rem;

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;

export const ReviewsGrid = styled.div`
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 1rem 2rem;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ReviewCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 2rem;
  min-width: 400px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .header {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .profile-image {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      object-fit: cover;
    }

    .profile-info {
      h3 {
        font-size: 1.3rem;
        color: #333;
        margin-bottom: 0.5rem;
      }

      .rating {
        display: flex;
        gap: 0.25rem;
        color: #ffc107;
        font-size: 1.2rem;
      }
    }
  }

  .service {
    font-size: 1.1rem;
    color: #666;
    font-style: italic;
  }

  .comment {
    font-size: 1.2rem;
    color: #444;
    line-height: 1.6;
  }

  .date {
    font-size: 1rem;
    color: #888;
    align-self: flex-end;
  }

  @media (max-width: 768px) {
    min-width: 350px;
    padding: 1.5rem;

    .header {
      .profile-image {
        width: 60px;
        height: 60px;
      }

      .profile-info {
        h3 {
          font-size: 1.2rem;
        }
      }
    }

    .comment {
      font-size: 1.1rem;
    }
  }
`;

export const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #333;
  z-index: 1;
  font-size: 1.2rem;

  &:hover {
    background: #f0f0f0;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
`;
